import React, { useContext, useEffect, useRef, useState } from "react";

import { Field, Form, Formik } from "formik";
import { head } from "lodash";
import { toast } from "react-toastify";


import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import { green } from "@material-ui/core/colors";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import moment from "moment-timezone";
import { i18n } from "../../translate/i18n";

import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Divider,
  Typography,
  FormControlLabel,
  Checkbox,
  ListItemText,
  Paper,
} from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import MessageVariablesPicker from "../MessageVariablesPicker";
import DateTimePickerWithTimezone from "../FormFields/DateTimePickerWithTimezone";
import { getCampaignTimezone, getCampaignTimezoneSync, setCampaignTimezoneCache } from "../../helpers/getCampaignTimezone";
import { calculateEstimatedTime } from "../../utils/campaignCalculations";

const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: Root dinámico según tema
  root: {
    display: "flex",
    flexWrap: "wrap",
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : theme.palette.background.paper,
  },

  tabmsg: {
    backgroundColor: theme.palette.campaigntab,
  },

  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  
  // ✅ ESTILOS DE BOTONES MEJORADOS
  primaryButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },
  
  secondaryButton: {
    color: '#1976d2',
    borderColor: '#1976d2',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.1)',
      borderColor: '#1565c0',
    },
  },
  
  // ✅ CORREGIDO: DialogTitle dinámico según tema
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontWeight: 'bold',
    padding: theme.spacing(2),
  },
  
  // ✅ CORREGIDO: DialogContent dinámico según tema
  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#fafafa',
  },
  
  // ✅ CORREGIDO: DialogActions dinámico según tema
  dialogActions: {
    padding: theme.spacing(2),
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#f5f5f5',
    borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : theme.palette.divider}`,
    justifyContent: 'space-between',
  },
  
  // ✅ CORREGIDO: FormSection dinámico según tema
  formSection: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e1e5e9'}`,
  },
  
  // ✅ CORREGIDO: SectionTitle dinámico según tema
  sectionTitle: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    paddingBottom: theme.spacing(1),
  },
  
  // ✅ CORREGIDO: FormControl dinámico según tema
  formControl: {
    width: '100%',
  },
  
  // ✅ CORREGIDO: SelectField dinámico según tema
  selectField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      },
    },
  },
}));



const CampaignModal = ({
  open,
  onClose,
  campaignId,
  initialValues,
  onSave,
  resetPagination,
  campaignType = 'UNICA', // 'UNICA' o 'RECURRENTE'
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMounted = useRef(true);
  const { user } = useContext(AuthContext);
  const { companyId } = user;
  const [file, setFile] = useState(null);

  const initialState = {
    name: "",
    message1: "",
    message2: "",
    message3: "",
    message4: "",
    message5: "",
    confirmationMessage1: "",
    confirmationMessage2: "",
    confirmationMessage3: "",
    confirmationMessage4: "",
    confirmationMessage5: "",
    status: "INATIVA", // INATIVA, PROGRAMADA, EM_ANDAMENTO, CANCELADA, FINALIZADA,
    confirmation: false,
    scheduledAt: "",
    whatsappId: "",
    contactListId: "",
    tagListId: "",
    companyId,
    // ✅ FASE 4: TIPO DE CAMPAÑA
    tipo: campaignType || 'UNICA',
    // ✅ CAMPOS DE RECURRENCIA
    isRecurring: campaignType === 'RECURRENTE',
    recurrenceType: "",
    recurrenceInterval: "",
    recurrenceDaysOfWeek: "",
    recurrenceDayOfMonth: "",
    recurrenceEndDate: "",
    maxExecutions: "",
    // ✅ CAMPOS DE INTERVALOS
    messageInterval: 45,
    longerIntervalAfter: 20,
    greaterInterval: 60,
    // ✅ CAMPOS DE ETIQUETADO AUTOMÁTICO (independiente de tagListId)
    autoTagEnabled: false,
    autoTagId: null,
  };

  const [campaign, setCampaign] = useState(initialState);
  const [formKey, setFormKey] = useState(0); // ✅ Key para forzar reinicialización de Formik
  const lastWrittenNameRef = useRef(""); // ✅ CRÍTICO: Rastrear el último nombre que el usuario escribió
  const [whatsapps, setWhatsapps] = useState([]);
  const [contactLists, setContactLists] = useState([]);
  const [messageTab, setMessageTab] = useState(0);
  const [configTab, setConfigTab] = useState(0); // Tab de configuración (MENSAJE, INTERVALO, ETIQUETADO, RECURRENCIA)
  const [attachment, setAttachment] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [campaignEditable, setCampaignEditable] = useState(true);
  const attachmentFile = useRef(null);
  const [tagLists, setTagLists] = useState([]);
  const [isFileListSelected, setIsFileListSelected] = useState(false);
  const [isAttachmentSelected, setIsAttachmentSelected] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedContactListCount, setSelectedContactListCount] = useState(null);
  const [datePastModalOpen, setDatePastModalOpen] = useState(false);
  const [datePastMessage, setDatePastMessage] = useState("");
  const [pendingSetFieldValue, setPendingSetFieldValue] = useState(null);
  const [pendingSaveValues, setPendingSaveValues] = useState(null);
  const saveCampaignRef = useRef(null);
  const [shortTimeModalOpen, setShortTimeModalOpen] = useState(false);
  const [shortTimeMessage, setShortTimeMessage] = useState("");
  const [pendingScheduledAt, setPendingScheduledAt] = useState(null);
  const [formatInvalidModalOpen, setFormatInvalidModalOpen] = useState(false);
  const [formatInvalidMessage, setFormatInvalidMessage] = useState("");
  const [sizeExceededModalOpen, setSizeExceededModalOpen] = useState(false);
  const [sizeExceededMessage, setSizeExceededMessage] = useState("");
  const [attachmentInfo, setAttachmentInfo] = useState(null);
  const [companyTimezone, setCompanyTimezone] = useState(getCampaignTimezoneSync()); // Estado para zona horaria

  // ✅ FASE 4: Determinar tipo de campaña (UNICA o RECURRENTE)
  const currentCampaignType = React.useMemo(() => {
    if (campaignId) {
      // ✅ CORRECCIÓN CRÍTICA: Usar el campo 'tipo' como fuente de verdad principal
      // Si 'tipo' está establecido y es válido, usarlo directamente
      if (campaign.tipo === 'UNICA' || campaign.tipo === 'RECURRENTE') {
        return campaign.tipo;
      }
      
      // ✅ Si 'tipo' no está establecido, determinar desde otros campos
      // 1. Si isRecurring es explícitamente false, es UNICA
      if (campaign.isRecurring === false || campaign.isRecurring === 0 || campaign.isRecurring === '0') {
        return 'UNICA';
      }
      // 2. Si isRecurring es explícitamente true, es RECURRENTE
      if (campaign.isRecurring === true || campaign.isRecurring === 1 || campaign.isRecurring === '1') {
        return 'RECURRENTE';
      }
      // 3. Si tiene campos de recurrencia configurados, es RECURRENTE
      if (campaign.recurrenceType || campaign.recurrenceInterval) {
        return 'RECURRENTE';
      }
      // 4. Por defecto, es UNICA
      return 'UNICA';
    }
    // Si no hay campaignId, usar el campaignType del prop
    return campaignType || 'UNICA';
  }, [campaignId, campaign.tipo, campaign.isRecurring, campaign.recurrenceType, campaign.recurrenceInterval, campaignType]);

  // ✅ SINCRONIZAR ZONA HORARIA AL ABRIR EL MODAL
  useEffect(() => {
    if (open && companyId) {
      // Sincronizar desde Settings al abrir el modal
      getCampaignTimezone(companyId)
        .then((timezone) => {
          setCompanyTimezone(timezone);
          setCampaignTimezoneCache(timezone);
        })
        .catch((error) => {
          console.warn("[CampaignModal] Error obteniendo zona horaria, usando cache:", error);
          const cached = getCampaignTimezoneSync();
          setCompanyTimezone(cached);
        });
    }
  }, [open, companyId]);

  // Función para manejar cambios en lista de contactos
  const handleContactListChange = (value, setFieldValue) => {
    setFieldValue("contactListId", value);
    // ✅ CORRECCIÓN: Limpiar error de nombre duplicado cuando el usuario cambia la lista de contactos
    if (errorMessage && (errorMessage.includes("nombre de campaña") || errorMessage.includes("ya existe"))) {
      setErrorMessage("");
      setErrorModalOpen(false);
    }
    if (value && value !== "") {
      setFieldValue("tagListId", "");
      // Buscar la lista seleccionada para obtener el conteo
      const selectedList = contactLists.find(list => list.id === parseInt(value));
      if (selectedList && selectedList.contactsCount !== undefined) {
        setSelectedContactListCount(selectedList.contactsCount);
      } else {
        setSelectedContactListCount(null);
      }
    } else {
      setSelectedContactListCount(null);
    }
  };

  // Función para manejar cambios en lista de etiquetas
  const handleTagListChange = (value, setFieldValue) => {
    setFieldValue("tagListId", value);
    // ✅ CORRECCIÓN: Limpiar error de nombre duplicado cuando el usuario cambia la lista de etiquetas
    if (errorMessage && (errorMessage.includes("nombre de campaña") || errorMessage.includes("ya existe"))) {
      setErrorMessage("");
      setErrorModalOpen(false);
    }
    if (value && value !== "") {
      setFieldValue("contactListId", "");
    }
  };

  // Función para manejar cambios en lista de archivos
  const handleFileListChange = (value, setFieldValue) => {
    setFieldValue("fileListId", value);
    setIsFileListSelected(value && value !== "");
    if (value && value !== "") {
      setIsAttachmentSelected(false);
    }
  };

  // Función para manejar adjuntar archivo
  const handleAttachFile = () => {
    setIsAttachmentSelected(true);
    setIsFileListSelected(false);
  };

  // Función para validación manual
  const validateForm = (values) => {
    const errors = {};
    
    // Validar nombre
    if (!values.name || values.name.trim() === "") {
      errors.name = "El nombre de la campaña es obligatorio";
    } else if (values.name.trim().length < 3) {
      errors.name = "El nombre debe tener al menos 3 caracteres";
    } else if (values.name.trim().length > 40) {
      errors.name = "El nombre no puede exceder 40 caracteres";
    }
    
    // Validar conexión
    if (!values.whatsappId || values.whatsappId === "") {
      errors.whatsappId = "La conexión es obligatoria";
    }
    
    // Validar fecha programada
    if (!values.scheduledAt || values.scheduledAt === "") {
      errors.scheduledAt = "La fecha programada es obligatoria";
    }
    
    // Validar lista de contactos o etiquetas
    const hasContactOrTag = (values.contactListId && values.contactListId !== "") || 
                           (values.tagListId && values.tagListId !== "");
    if (!hasContactOrTag) {
      errors.contactListId = "Debe seleccionar una lista de contactos o una lista de etiquetas";
    }
    
    // Validar al menos un mensaje
    const hasMessage = (values.message1 && values.message1.trim() !== "") || 
                      (values.message2 && values.message2.trim() !== "") || 
                      (values.message3 && values.message3.trim() !== "") || 
                      (values.message4 && values.message4.trim() !== "") || 
                      (values.message5 && values.message5.trim() !== "");
    if (!hasMessage) {
      // Mostrar error en el primer campo de mensaje
      errors.message1 = "Debe ingresar al menos un mensaje";
    }
    
    // ✅ VALIDACIONES DE RECURRENCIA
    // ✅ CORRECCIÓN: Validar también por tipo de campaña, no solo por isRecurring
    const isRecurrentCampaign = values.isRecurring || values.tipo === 'RECURRENTE' || campaignType === 'RECURRENTE';
    if (isRecurrentCampaign) {
      if (!values.recurrenceType || values.recurrenceType === "") {
        errors.recurrenceType = "El tipo de recurrencia es obligatorio";
      }
      
      // ✅ Validar intervalo: convertir a número y validar
      // Permitir valores 1, 2, 3, etc. (incluyendo 1)
      const intervalValue = values.recurrenceInterval;
      if (intervalValue === undefined || intervalValue === null || intervalValue === "") {
        errors.recurrenceInterval = "El intervalo es obligatorio";
      } else {
        // Convertir a número (manejar string "1", número 1, etc.)
        let intervalNum;
        if (typeof intervalValue === 'string') {
          const trimmed = intervalValue.trim();
          if (trimmed === '') {
            errors.recurrenceInterval = "El intervalo es obligatorio";
          } else {
            intervalNum = parseInt(trimmed, 10);
          }
        } else {
          intervalNum = Number(intervalValue);
        }
        
        // Validar solo si se pudo convertir
        if (intervalNum !== undefined) {
          if (isNaN(intervalNum) || intervalNum < 1) {
            errors.recurrenceInterval = "El intervalo debe ser mayor a 0";
          } else if (!Number.isInteger(intervalNum)) {
            errors.recurrenceInterval = "El intervalo debe ser un número entero";
          }
          // ✅ Si intervalNum === 1, NO agregar error (permitir valor 1)
        }
      }
      
      if (values.recurrenceType === "semanal" && !values.recurrenceDaysOfWeek) {
        errors.recurrenceDaysOfWeek = "Debe seleccionar al menos un día de la semana";
      }
      
      if (values.recurrenceType === "mensual" && values.recurrenceDayOfMonth) {
        if (values.recurrenceDayOfMonth < 1 || values.recurrenceDayOfMonth > 31) {
          errors.recurrenceDayOfMonth = "El día del mes debe estar entre 1 y 31";
        }
      }
    }
    
    // ✅ REMOVIDO: Log que causaba spam en consola
    return errors;
  };

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/files/", {
          params: { companyId }
        });

        setFile(data.files);
      } catch (err) {
        toastError(err);
      }
    })();
  }, [companyId]);

  useEffect(() => {
    if (isMounted.current) {
      // ✅ LIMPIEZA COMPLETA: Si es nueva campaña (sin campaignId), resetear TODO
      if (!campaignId && open) {
        setCampaign({
          name: "",
          message1: "",
          message2: "",
          message3: "",
          message4: "",
          message5: "",
          confirmationMessage1: "",
          confirmationMessage2: "",
          confirmationMessage3: "",
          confirmationMessage4: "",
          confirmationMessage5: "",
          status: "INATIVA",
          confirmation: false,
          scheduledAt: "",
          whatsappId: "",
          contactListId: "",
          tagListId: "",
          companyId,
          // ✅ CORRECCIÓN: Establecer isRecurring según campaignType
          tipo: campaignType || 'UNICA',
          isRecurring: campaignType === 'RECURRENTE',
          recurrenceType: "",
          recurrenceInterval: "",
          recurrenceDaysOfWeek: "",
          recurrenceDayOfMonth: "",
          recurrenceEndDate: "",
          maxExecutions: "",
          messageInterval: 45,
          longerIntervalAfter: 20,
          greaterInterval: 60,
        });
        setAttachment(null);
        setAttachmentInfo(null);
        setIsFileListSelected(false);
        setIsAttachmentSelected(false);
        setSelectedContactListCount(null);
        setMessageTab(0);
        setConfigTab(0); // ✅ FASE 4: Resetear tab de configuración
        // Limpiar input de archivo si existe
        if (attachmentFile.current) {
          attachmentFile.current.value = '';
        }
      }

      if (initialValues) {
        setCampaign((prevState) => {
          return { ...prevState, ...initialValues };
        });
      }

      // ✅ MEJORA: Obtener última campaña activa para sugerir fecha programada
      if (!campaignId) {
        // ✅ CORRECCIÓN: Usar zona horaria sincronizada desde Settings
        const timezone = getCampaignTimezoneSync();
        
        api.get(`/campaigns/last-active`)
          .then(({ data: lastActiveCampaign }) => {
            if (lastActiveCampaign && (lastActiveCampaign.scheduledAt || lastActiveCampaign.nextScheduledAt)) {
              // Usar nextScheduledAt si existe (recurrentes), sino scheduledAt
              const lastDate = lastActiveCampaign.nextScheduledAt || lastActiveCampaign.scheduledAt;
              if (lastDate) {
                // ✅ CORRECCIÓN: Interpretar lastDate en la zona horaria de la empresa
                // El backend devuelve fechas como strings "YYYY-MM-DD HH:mm:ss" en zona empresa
                let lastMoment = moment.tz(String(lastDate), 'YYYY-MM-DD HH:mm:ss', timezone);
                if (!lastMoment.isValid()) {
                  lastMoment = moment.tz(String(lastDate), timezone);
                }
                
                // Calcular nueva fecha: última fecha + 30 minutos (en zona empresa)
                let newDate = lastMoment.add(30, 'minutes');
                
                // Validar que no sea en el pasado (comparar en zona empresa)
                const nowInCompanyTimezone = moment().tz(timezone);
                if (newDate.isBefore(nowInCompanyTimezone)) {
                  // Si está en el pasado, usar ahora + 30 min (en zona empresa)
                  newDate = nowInCompanyTimezone.add(30, 'minutes');
                }
                
                // ✅ CORRECCIÓN: DateTimePickerWithTimezone espera formato "YYYY-MM-DD HH:mm:ss"
                // Formatear directamente en zona empresa (sin conversión)
                const formattedDate = newDate.format('YYYY-MM-DD HH:mm:ss');
                
                // Establecer en estado
                setCampaign((prevState) => ({
                  ...prevState,
                  scheduledAt: formattedDate
                }));
              }
            } else {
              // No hay campañas activas, usar fecha actual + 30 min EN ZONA EMPRESA
              const nowInCompanyTimezone = moment().tz(timezone);
              const newDate = nowInCompanyTimezone.add(30, 'minutes');
              // ✅ CORRECCIÓN: DateTimePickerWithTimezone espera formato "YYYY-MM-DD HH:mm:ss"
              const formattedDate = newDate.format('YYYY-MM-DD HH:mm:ss');
              setCampaign((prevState) => ({
                ...prevState,
                scheduledAt: formattedDate
              }));
            }
          })
          .catch((error) => {
            // Silenciar error, no es crítico - usar fecha actual + 30 min como fallback
            console.debug("No se pudo obtener última campaña activa, usando fecha actual + 30 min:", error);
            const timezoneFallback = getCampaignTimezoneSync();
            const nowInCompanyTimezone = moment().tz(timezoneFallback);
            const newDate = nowInCompanyTimezone.add(30, 'minutes');
            // ✅ CORRECCIÓN: DateTimePickerWithTimezone espera formato "YYYY-MM-DD HH:mm:ss"
            const formattedDate = newDate.format('YYYY-MM-DD HH:mm:ss');
            setCampaign((prevState) => ({
              ...prevState,
              scheduledAt: formattedDate
            }));
          });
        return;
      }

      api.get(`/campaigns/${campaignId}`).then(({ data }) => {
        setCampaign((prev) => {
          let prevCampaignData = Object.assign({}, prev);

          // ✅ Obtener zona horaria de la empresa para campañas (desde estado sincronizado)
          const timezone = getCampaignTimezoneSync();
          
          // ✅ CORRECCIÓN CRÍTICA: Para campañas RECURRENTES que ya ejecutaron, usar nextScheduledAt
          // en lugar de scheduledAt para el campo de fecha programada
          const isRecurringActive = (data.tipo === 'RECURRENTE' || data.isRecurring) && 
                                    data.executionCount && 
                                    data.executionCount > 0 && 
                                    (data.status === 'PROGRAMADA' || data.status === 'ACTIVA');
          
          Object.entries(data).forEach(([key, value]) => {
            if (key === "scheduledAt" && value !== "" && value !== null) {
              // ✅ CORRECCIÓN: Para campañas RECURRENTES activas, guardar scheduledAt original
              // pero usar nextScheduledAt para el campo de edición
              if (isRecurringActive && data.nextScheduledAt) {
                // Guardar scheduledAt original para referencia
                prevCampaignData.originalScheduledAt = String(value);
                // Usar nextScheduledAt para el campo de edición
                prevCampaignData[key] = String(data.nextScheduledAt);
              } else {
                // ✅ CORRECCIÓN: El backend devuelve scheduledAt como string "YYYY-MM-DD HH:mm:ss" 
                // en la zona horaria de la empresa. Necesitamos interpretarlo en esa zona horaria
                // y luego convertir a la zona horaria del navegador para el input datetime-local
                // ✅ CORRECCIÓN: DateTimePickerWithTimezone espera formato "YYYY-MM-DD HH:mm:ss"
                // El backend ya devuelve en ese formato, así que usamos directamente
                // El componente se encargará de la conversión interna
                prevCampaignData[key] = String(value);
              }
            } else if (key === "recurrenceEndDate" && value !== "" && value !== null) {
              // ✅ CORRECCIÓN: Para recurrenceEndDate mantenemos formato datetime-local
              // porque no usamos DateTimePickerWithTimezone para este campo
              const endDateMoment = moment.tz(String(value), 'YYYY-MM-DD HH:mm:ss', timezone);
              if (endDateMoment.isValid()) {
                prevCampaignData[key] = endDateMoment.local().format("YYYY-MM-DDTHH:mm");
              } else {
                const fallbackMoment = moment.tz(String(value), timezone);
                if (fallbackMoment.isValid()) {
                  prevCampaignData[key] = fallbackMoment.local().format("YYYY-MM-DDTHH:mm");
                } else {
                  prevCampaignData[key] = moment(value).format("YYYY-MM-DDTHH:mm");
                }
              }
            } else if (key === "tipo") {
              // ✅ FASE 4: Establecer tipo de campaña
              prevCampaignData[key] = value || (data.isRecurring ? 'RECURRENTE' : 'UNICA');
            } else if (key === "isRecurring") {
              // ✅ CORRECCIÓN: Asegurar que isRecurring sea boolean
              if (value === true || value === 1 || value === '1' || value === 'true') {
                prevCampaignData[key] = true;
              } else if (value === false || value === 0 || value === '0' || value === 'false' || value === null || value === '') {
                prevCampaignData[key] = false;
              } else {
                prevCampaignData[key] = value;
              }
            } else if (key === "recurrenceDaysOfWeek") {
              // ✅ CORRECCIÓN: Asegurar que recurrenceDaysOfWeek se cargue correctamente
              // Puede venir como null, string vacío, JSON string, o array
              if (value === null || value === undefined || value === '') {
                prevCampaignData[key] = "";
              } else if (Array.isArray(value)) {
                // Si viene como array, convertirlo a JSON string
                prevCampaignData[key] = JSON.stringify(value);
              } else if (typeof value === 'string') {
                // Si ya es un string, verificar si es JSON válido
                try {
                  const parsed = JSON.parse(value);
                  // Si es un array válido, mantenerlo como JSON string
                  if (Array.isArray(parsed)) {
                    prevCampaignData[key] = value;
                  } else {
                    // No es un array, intentar convertirlo
                    prevCampaignData[key] = JSON.stringify([parsed]);
                  }
                } catch (e) {
                  // No es JSON válido, intentar parsearlo como array de números
                  // Ejemplo: "0,1,2" o "[0,1,2]" sin comillas
                  const cleaned = value.replace(/[[\]]/g, '');
                  const numbers = cleaned.split(',').map(n => parseInt(n.trim())).filter(n => !isNaN(n));
                  if (numbers.length > 0) {
                    prevCampaignData[key] = JSON.stringify(numbers);
                  } else {
                    prevCampaignData[key] = "";
                  }
                }
              } else {
                prevCampaignData[key] = value;
              }
              
              // ✅ DEBUG: Log temporal para verificar carga (comentado para producción)
              // if (key === "recurrenceDaysOfWeek") {
              //   console.log('[CampaignModal] 🔍 recurrenceDaysOfWeek cargado:', {
              //     originalValue: value,
              //     tipo: typeof value,
              //     processedValue: prevCampaignData[key],
              //     parsed: prevCampaignData[key] && prevCampaignData[key] !== "" ? (() => {
              //       try {
              //         return JSON.parse(prevCampaignData[key]);
              //       } catch (e) {
              //         return "ERROR_PARSING";
              //       }
              //     })() : null
              //   });
              // }
            } else {
              prevCampaignData[key] = value === null ? "" : value;
            }
          });

          // ✅ FASE 4: Asegurar que tipo esté establecido correctamente
          // Verificar múltiples formas de determinar si es RECURRENTE
          // ✅ CORRECCIÓN CRÍTICA: Primero verificar explícitamente si NO es recurrente
          if (!prevCampaignData.tipo || prevCampaignData.tipo === '') {
            // 1. Si isRecurring es explícitamente false, es UNICA
            if (prevCampaignData.isRecurring === false || prevCampaignData.isRecurring === 0 || prevCampaignData.isRecurring === '0' || prevCampaignData.isRecurring === false) {
              prevCampaignData.tipo = 'UNICA';
            }
            // 2. Si isRecurring es explícitamente true, es RECURRENTE
            else if (prevCampaignData.isRecurring === true || prevCampaignData.isRecurring === 1 || prevCampaignData.isRecurring === '1') {
              prevCampaignData.tipo = 'RECURRENTE';
            }
            // 3. Verificar si tiene campos de recurrencia configurados
            else if (prevCampaignData.recurrenceType || prevCampaignData.recurrenceInterval) {
              prevCampaignData.tipo = 'RECURRENTE';
            }
            // 4. Por defecto, es UNICA
            else {
              prevCampaignData.tipo = 'UNICA';
            }
          }
          
          // ✅ CORRECCIÓN CRÍTICA: Si tipo es 'UNICA', asegurar que isRecurring sea false
          if (prevCampaignData.tipo === 'UNICA') {
            prevCampaignData.isRecurring = false;
          }
          // ✅ CORRECCIÓN: Si tipo es 'RECURRENTE', asegurar que isRecurring sea true
          else if (prevCampaignData.tipo === 'RECURRENTE') {
            prevCampaignData.isRecurring = true;
          }

          // ✅ DEBUG: Log temporal para verificar datos cargados (comentado para producción)
          // console.log('[CampaignModal] 🔍 Datos cargados de campaña:', {
          //   id: campaignId,
          //   tipo: prevCampaignData.tipo,
          //   isRecurring: prevCampaignData.isRecurring,
          //   recurrenceType: prevCampaignData.recurrenceType,
          //   recurrenceInterval: prevCampaignData.recurrenceInterval,
          //   dataFromAPI: {
          //     tipo: data.tipo,
          //     isRecurring: data.isRecurring
          //   }
          // });

          return prevCampaignData;
        });
        
        // ✅ FASE 4: Ajustar configTab según el tipo de campaña al cargar
        // Si es UNICA, configTab debe ser 0 (MENSAJE)
        // Si es RECURRENTE, configTab puede ser 0 (RECURRENCIA) o 1 (MENSAJE) según corresponda
        const loadedCampaignType = data.tipo || (data.isRecurring ? 'RECURRENTE' : 'UNICA');
        if (loadedCampaignType === 'UNICA') {
          // Para campañas UNICAS, siempre empezar en MENSAJE (índice 0)
          setConfigTab(0);
        } else {
          // Para campañas RECURRENTES, empezar en RECURRENCIA (índice 0)
          setConfigTab(0);
        }
        
        // ✅ CORRECCIÓN: Cargar el conteo de contactos para mostrar cálculos de tiempo
        // Prioridad 1: Usar totalContacts del backend si está disponible
        if (data.totalContacts !== undefined && data.totalContacts !== null) {
          setSelectedContactListCount(data.totalContacts);
        }
        // Prioridad 2: Usar contactListItems si están disponibles
        else if (data.contactList && data.contactList.contactListItems) {
          setSelectedContactListCount(data.contactList.contactListItems.length);
        }
        // Prioridad 3: Hacer petición para obtener el conteo (más confiable que buscar en estado)
        else if (data.contactListId) {
          api.get(`/contact-lists/${data.contactListId}`)
            .then(({ data: contactListData }) => {
              if (contactListData && contactListData.contactListItems) {
                setSelectedContactListCount(contactListData.contactListItems.length);
              } else if (contactListData && contactListData.contactsCount !== undefined) {
                setSelectedContactListCount(contactListData.contactsCount);
              }
            })
            .catch((err) => {
              console.warn("No se pudo cargar el conteo de contactos:", err);
            });
        }
      });
    }
  }, [campaignId, open, initialValues, companyId, campaignType]);
  
  // ✅ Separar carga de recursos (contactLists, whatsapps, tags) en useEffect independiente
  // Esto evita ciclo infinito cuando contactLists se actualiza
  useEffect(() => {
    if (open && isMounted.current) {
      api
        .get(`/contact-lists/list`, { params: { companyId } })
        .then(({ data }) => setContactLists(data));

      api
        .get(`/whatsapp`, { params: { companyId, session: 0 } })
        .then(({ data }) => setWhatsapps(data));

      api.get(`/tags`, { params: { companyId } })
        .then(({ data }) => {
          const fetchedTags = data.tags;
          // Perform any necessary data transformation here
          const formattedTagLists = fetchedTags.map((tag) => ({
            id: tag.id,
            name: tag.name,
          }));
          setTagLists(formattedTagLists);
        })
        .catch((error) => {
          console.error("Error retrieving tags:", error);
        });
    }
  }, [open, companyId]);
  
  // ✅ FASE 4: Ajustar configTab cuando cambia el tipo de campaña
  useEffect(() => {
    if (open && campaignId) {
      // Al editar, ajustar configTab según el tipo real de la campaña
      const campaignTypeToUse = campaign.tipo || (campaign.isRecurring ? 'RECURRENTE' : 'UNICA');
      if (campaignTypeToUse === 'UNICA') {
        // Para campañas UNICAS, asegurar que configTab esté en MENSAJE (0)
        if (configTab > 2) {
          setConfigTab(0); // MENSAJE
        }
      }
      // Para RECURRENTE, configTab puede estar en 0 (RECURRENCIA) o 1 (MENSAJE), está bien
    }
  }, [open, campaignId, campaign.tipo, campaign.isRecurring, configTab]);

  useEffect(() => {
    const now = moment();
    
    // ✅ REGLA 1: INATIVA siempre editable
    if (campaign.status === "INATIVA") {
      setCampaignEditable(true);
      return;
    }
    
    // ✅ REGLA 2: EM_ANDAMENTO nunca editable
    if (campaign.status === "EM_ANDAMENTO") {
      setCampaignEditable(false);
      return;
    }
    
    // ✅ REGLA 2.1: FINALIZADA - ÚNICAS en solo lectura, RECURRENTES no editables
    if (campaign.status === "FINALIZADA") {
      setCampaignEditable(false);
      return;
    }
    
    // ✅ REGLA 3: CANCELADA siempre editable (pausada o parada)
    if (campaign.status === "CANCELADA") {
      setCampaignEditable(true);
      return;
    }
    
    // ✅ REGLA 4: PROGRAMADA - Validar tiempo mínimo (10 minutos)
    if (campaign.status === "PROGRAMADA") {
      // Para campañas recurrentes activas, validar nextScheduledAt
      const timeToCheck = campaign.isRecurring && campaign.executionCount > 0 && campaign.nextScheduledAt
        ? moment(campaign.nextScheduledAt)
        : moment(campaign.scheduledAt);
      
      if (!timeToCheck.isValid()) {
        setCampaignEditable(false);
        return;
      }
      
      const minutesUntilExecution = timeToCheck.diff(now, "minutes");
      const hasEnoughTime = minutesUntilExecution > 10;
      
      setCampaignEditable(hasEnoughTime);
      return;
    }
    
    // ✅ Por defecto, no editable
    setCampaignEditable(false);
  }, [campaign.status, campaign.scheduledAt, campaign.nextScheduledAt, campaign.isRecurring, campaign.executionCount]);

  // ✅ NOTA: El cálculo de tiempo estimado ahora se hace directamente en el render
  // usando `currentCalculatedTime` calculado con los valores de Formik `values`

  const handleClose = () => {
    onClose();
    // ✅ CORRECCIÓN: Resetear TODO el estado del formulario
    setCampaign(initialState);
    setFormKey(prev => prev + 1); // ✅ Forzar reinicialización de Formik cambiando la key
    lastWrittenNameRef.current = ""; // ✅ CRÍTICO: Limpiar el ref del último nombre escrito
    setAttachment(null);
    setAttachmentInfo(null);
    setIsFileListSelected(false);
    setIsAttachmentSelected(false);
    setSelectedContactListCount(null);
    setMessageTab(0);
    setConfigTab(0); // ✅ FASE 4: Resetear tab de configuración
    setErrorMessage(""); // ✅ Limpiar mensajes de error
    setErrorModalOpen(false); // ✅ Cerrar modales de error
    // Limpiar input de archivo si existe
    if (attachmentFile.current) {
      attachmentFile.current.value = '';
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  };

  const truncateFileName = (fileName, maxLength = 50) => {
    if (fileName.length <= maxLength) return fileName;
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
    const truncatedName = nameWithoutExt.substring(0, maxLength - extension.length - 3) + '...';
    return truncatedName + extension;
  };

  const getFileType = (fileName) => {
    const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
    const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm'];
    const audioExtensions = ['.mp3', '.ogg', '.wav', '.m4a'];
    const documentExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.csv'];
    
    if (imageExtensions.includes(extension)) return { type: 'image', maxSize: 10 * 1024 * 1024, typeName: 'imagen' };
    if (videoExtensions.includes(extension)) return { type: 'video', maxSize: 15 * 1024 * 1024, typeName: 'video' };
    if (audioExtensions.includes(extension)) return { type: 'audio', maxSize: 10 * 1024 * 1024, typeName: 'audio' };
    if (documentExtensions.includes(extension)) return { type: 'document', maxSize: 15 * 1024 * 1024, typeName: 'documento' };
    return null;
  };

  const handleAttachmentFile = (e) => {
    const file = head(e.target.files);
    if (file) {
      // ✅ Validar formato del archivo
      const fileType = getFileType(file.name);
      if (!fileType) {
        // Formato no permitido
        const allowedFormats = {
          images: '.jpg, .jpeg, .png, .gif, .webp',
          videos: '.mp4, .mov, .avi, .mkv, .webm',
          audios: '.mp3, .ogg, .wav, .m4a',
          documents: '.pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .csv'
        };
        setFormatInvalidMessage(
          `El formato del archivo "${file.name}" no está permitido.\n\nFormatos permitidos:\n` +
          `• Imágenes: ${allowedFormats.images}\n` +
          `• Videos: ${allowedFormats.videos}\n` +
          `• Audios: ${allowedFormats.audios}\n` +
          `• Documentos: ${allowedFormats.documents}`
        );
        setFormatInvalidModalOpen(true);
        // Limpiar input
        if (attachmentFile.current) {
          attachmentFile.current.value = null;
        }
        return;
      }

      // ✅ Validar tamaño del archivo
      if (file.size > fileType.maxSize) {
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        const maxSizeMB = (fileType.maxSize / (1024 * 1024)).toFixed(0);
        setSizeExceededMessage(
          `El ${fileType.typeName} "${file.name}" excede el tamaño máximo permitido.\n\n` +
          `Tamaño actual: ${fileSizeMB} MB\n` +
          `Tamaño máximo permitido: ${maxSizeMB} MB`
        );
        setSizeExceededModalOpen(true);
        // Limpiar input
        if (attachmentFile.current) {
          attachmentFile.current.value = null;
        }
        return;
      }

      // ✅ Archivo válido - guardar y mostrar información
      setAttachment(file);
      setIsAttachmentSelected(true);
      setAttachmentInfo({
        name: truncateFileName(file.name),
        fullName: file.name,
        size: formatFileSize(file.size),
        sizeBytes: file.size
      });
    }
  };

  const handleSaveCampaign = async (values, shouldSkipDateCheck = false, shouldSkipShortTimeCheck = false, setFieldValue = null) => {
    try {
      // ✅ Validar fecha programada en el pasado o < 10 minutos (filtro adicional en botón AGREGAR)
      if (!shouldSkipDateCheck && values.scheduledAt && values.scheduledAt !== "" && values.scheduledAt !== null) {
        // ✅ CORRECCIÓN: Usar zona horaria sincronizada desde Settings
        const timezone = getCampaignTimezoneSync();
        
        // Parsear scheduledAt en zona empresa (viene como string "YYYY-MM-DD HH:mm:ss")
        const scheduledMoment = moment.tz(values.scheduledAt, 'YYYY-MM-DD HH:mm:ss', timezone);
        
        // ✅ DEBUG: Verificar parseo
        if (!scheduledMoment.isValid()) {
          console.warn(`[CampaignModal] ⚠️ Fecha inválida al parsear:`, values.scheduledAt, timezone);
          // Si la fecha es inválida, continuar sin validación
        } else {
          const nowInCompanyTimezone = moment().tz(timezone);
          const diffMinutes = scheduledMoment.diff(nowInCompanyTimezone, 'minutes', true);
          
          // ✅ DEBUG: Log para validación de 10 minutos (usar console.log para que siempre se vea)
          // ✅ COMENTADO: Spam de logs deshabilitado
          // console.log(`[CampaignModal] 🔍 Validación de fecha:`, {
          //   scheduledAt: values.scheduledAt,
          //   scheduledMoment: scheduledMoment.format('YYYY-MM-DD HH:mm:ss'),
          //   nowInCompanyTimezone: nowInCompanyTimezone.format('YYYY-MM-DD HH:mm:ss'),
          //   diffMinutes: diffMinutes.toFixed(2),
          //   isBefore: scheduledMoment.isBefore(nowInCompanyTimezone),
          //   shouldSkipShortTimeCheck,
          //   shouldSkipDateCheck
          // });
          
          if (scheduledMoment.isBefore(nowInCompanyTimezone)) {
            // Fecha pasada
            // console.log(`[CampaignModal] ⚠️ Fecha en el pasado detectada`);
            const pastDiffMinutes = nowInCompanyTimezone.diff(scheduledMoment, 'minutes');
            const formattedDate = scheduledMoment.format('DD/MM/YYYY HH:mm');
            setDatePastMessage(
              `La fecha programada (${formattedDate}) está en el pasado (hace ${pastDiffMinutes} minutos).\n\n¿Desea actualizar la fecha a ahora mismo (hora actual + 2 minutos) para enviar la campaña inmediatamente?`
            );
            setPendingSaveValues(values);
            // Guardar referencia a setFieldValue para poder actualizar el campo
            setPendingSetFieldValue(setFieldValue);
            saveCampaignRef.current = (vals, skipDate, skipShort) => handleSaveCampaign(vals, skipDate, skipShort, null);
            setDatePastModalOpen(true);
            // Esperar respuesta del usuario antes de continuar
            return;
          } else if (diffMinutes > 0 && diffMinutes < 10 && !shouldSkipShortTimeCheck) {
            // ✅ REGLA DE NEGOCIO: Fecha futura pero < 10 minutos - mostrar modal informativo
            // console.log(`[CampaignModal] ⚠️ ALERTA: Fecha a menos de 10 minutos (${diffMinutes.toFixed(2)} minutos)`);
            const formattedDate = scheduledMoment.format('DD/MM/YYYY HH:mm');
            setShortTimeMessage(
              `La fecha programada (${formattedDate}) está a menos de 10 minutos (${Math.ceil(diffMinutes)} minutos). Si programa con menos de 10 minutos, no tendrá opción a modificar esta campaña ya que los tiempos son muy cortos para su procesamiento. Se sugiere programar envíos mayores a 30 minutos.`
            );
            setPendingSaveValues(values);
            setPendingScheduledAt(values.scheduledAt); // ✅ Guardar el valor de scheduledAt
            saveCampaignRef.current = (vals, skipDate, skipShort) => handleSaveCampaign(vals, skipDate, skipShort, null);
            setShortTimeModalOpen(true);
            // Esperar respuesta del usuario antes de continuar
            return;
          } else {
            // console.log(`[CampaignModal] ✅ Validación de fecha pasada: diffMinutes=${diffMinutes.toFixed(2)}, dentro de rango permitido`);
          }
        }
      }

      // ✅ CRÍTICO: Usar el último nombre que el usuario escribió (fuente de verdad)
      // El ref mantiene el valor más reciente que el usuario escribió, independientemente de reinicializaciones de Formik
      const finalName = lastWrittenNameRef.current && lastWrittenNameRef.current.trim() !== "" 
        ? lastWrittenNameRef.current 
        : (campaign.name && campaign.name.trim() !== "" ? campaign.name : (values.name || ""));

      // ✅ Obtener zona horaria de la empresa para campañas (desde estado sincronizado)
      const timezone = getCampaignTimezoneSync();
      
      const dataValues = {};
      Object.entries(values).forEach(([key, value]) => {
        // ✅ CRÍTICO: Para el campo 'name', usar el valor más reciente (finalName tiene prioridad)
        if (key === "name") {
          dataValues[key] = finalName || value || "";
          return;
        }
        if (key === "scheduledAt" && value !== "" && value !== null) {
          // ✅ CORRECCIÓN: DateTimePickerWithTimezone ya devuelve string en formato "YYYY-MM-DD HH:mm:ss"
          // en la zona horaria de la empresa, así que solo validamos y usamos directamente
          // El componente ya hizo la conversión correcta
          
          if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
            // ✅ Ya viene en formato correcto, usar directamente
            dataValues[key] = value;
          } else {
            // ⚠️ PROBLEMA: Este fallback aplica conversión de timezone incorrecta
            // Si el componente devuelve el formato correcto, este código no debería ejecutarse
            const browserMoment = moment(value);
            const companyMoment = browserMoment.clone().tz(timezone);
            dataValues[key] = companyMoment.format("YYYY-MM-DD HH:mm:ss");
          }
        } else if (key === "recurrenceEndDate" && value !== "" && value !== null) {
          // ✅ Misma lógica para recurrenceEndDate
          const browserMoment = moment(value);
          const companyMoment = browserMoment.clone().tz(timezone);
          dataValues[key] = companyMoment.format("YYYY-MM-DD HH:mm:ss");
        } else if (key === "recurrenceInterval") {
          // ✅ Si es recurrente y el intervalo está vacío/null, usar valor por defecto 1
          if (values.isRecurring && (value === "" || value === null || value === undefined)) {
            dataValues[key] = 1;
          } else {
            dataValues[key] = value === "" ? null : value;
          }
        } else {
          dataValues[key] = value === "" ? null : value;
        }
      });

      if (campaignId) {
        await api.put(`/campaigns/${campaignId}`, dataValues);

        if (attachment != null) {
          try {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/campaigns/${campaignId}/media-upload`, formData);
          } catch (uploadError) {
            console.error("Error al subir archivo:", uploadError);
            const uploadErrorMsg = uploadError?.response?.data?.error || uploadError?.message || "Error al subir archivo";
            toast.error(`Campaña actualizada, pero hubo un error al subir el archivo: ${uploadErrorMsg}`);
        }
        }
        
        // ✅ CORRECCIÓN: El backend ya emite el mensaje socket, no es necesario hacerlo desde el frontend
        // El backend emite en CampaignController.update() después de UpdateService
        handleClose();
      } else {
        const { data } = await api.post("/campaigns", dataValues);

        if (attachment != null) {
          try {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/campaigns/${data.id}/media-upload`, formData);
          } catch (uploadError) {
            console.error("Error al subir archivo:", uploadError);
            const uploadErrorMsg = uploadError?.response?.data?.error || uploadError?.message || "Error al subir archivo";
            toast.warning(`Campaña creada exitosamente, pero hubo un error al subir el archivo: ${uploadErrorMsg}`);
          }
        }
        if (onSave) {
          onSave(data);
        }
        // ✅ CORRECCIÓN: Resetear formulario COMPLETAMENTE antes de cerrar el modal
        // Esto asegura que el formulario esté limpio para la próxima creación
        // ✅ CRÍTICO: Verificar que el componente esté montado antes de actualizar estados
        if (isMounted.current) {
          setCampaign(initialState);
          setFormKey(prev => prev + 1); // ✅ CRÍTICO: Forzar reinicialización completa de Formik
          lastWrittenNameRef.current = ""; // ✅ CRÍTICO: Limpiar el ref del último nombre escrito
          setAttachment(null);
          setAttachmentInfo(null);
          setIsFileListSelected(false);
          setIsAttachmentSelected(false);
          setSelectedContactListCount(null);
          setMessageTab(0);
          setConfigTab(0);
          setErrorMessage(""); // ✅ Limpiar mensajes de error
          setErrorModalOpen(false); // ✅ Cerrar modales de error
          if (attachmentFile.current) {
            attachmentFile.current.value = '';
        }
        handleClose();
        }
      }
      toast.success(i18n.t("campaigns.toasts.success"));
    } catch (err) {
      console.log(err);
      const errorMsg = err?.response?.data?.error || err?.message || String(err);
      const errorCode = err?.response?.data?.code;
      
      // ✅ CRÍTICO: Verificar que el componente esté montado antes de actualizar estados
      if (!isMounted.current) {
        return; // Componente desmontado, no actualizar estados
      }
      
      // ✅ CORRECCIÓN: Verificar si el error es de tiempo < 10 minutos (solo en edición)
      if (campaignId && (errorCode === "ERR_CAMPAIGN_SHORT_TIME" || (errorMsg.includes("10 minutos") && errorMsg.includes("anticipación")))) {
        setShortTimeMessage(errorMsg);
        setPendingSaveValues(values); // Guardar valores para referencia
        saveCampaignRef.current = (vals, skipDate, skipShort) => handleSaveCampaign(vals, skipDate, skipShort, null);
        setShortTimeModalOpen(true);
        return; // No mostrar toast, el modal se encargará
      }
      
      // Verificar si el error es de nombre duplicado
      if (errorMsg.includes("nombre de campaña") && errorMsg.includes("ya existe")) {
        // ✅ CORRECCIÓN: NO limpiar el campo name - el usuario debe poder corregirlo sin perder el valor
        // El error se limpiará automáticamente cuando el usuario cambie el nombre (ver onChange del campo name)
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
        // ✅ IMPORTANTE: NO cerrar el modal ni resetear el formulario - el usuario debe poder corregir el nombre
      }
      // ✅ MEJORA UX: Verificar si el error es de conflicto de horarios
      else if (errorMsg.includes("Horario no disponible") || errorMsg.includes("Conflicto con") || errorMsg.includes("Siguiente disponible")) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      }
      // ✅ NUEVO: Verificar si el error es de solapamiento de campañas
      else if (errorMsg.includes("No se puede programar la campaña")) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      }
      // ✅ MEJORA UX: Cambiar errores de validación importantes a MODAL en lugar de toast
      else if (errorMsg.includes("conexión WhatsApp") || errorMsg.includes("WhatsApp") || errorMsg.includes("no está activa")) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      }
      else if (errorMsg.includes("lista de contactos") || errorMsg.includes("contactListId") || errorMsg.includes("Lista de contactos")) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      }
      else if (errorMsg.includes("No se proporcionó ningún archivo") || errorMsg.includes("archivo")) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      }
      else {
        // Solo errores genéricos/no críticos usan toast
        toastError(err);
      }
    }
  };

  const deleteMedia = async () => {
    if (attachment) {
      setAttachment(null);
      attachmentFile.current.value = null;
      setIsAttachmentSelected(false);
      setAttachmentInfo(null);
    }

    if (campaign.mediaPath) {
      await api.delete(`/campaigns/${campaign.id}/media-upload`);
      setCampaign((prev) => ({ ...prev, mediaPath: null, mediaName: null }));
      toast.success(i18n.t("campaigns.toasts.deleted"));
    }
  };

  const handleClickMsgVar = (msgVar, setFieldValue) => {
    const el = document.getElementById(`message${messageTab + 1}`);
    if (el) {
      const firstHalfText = el.value.substring(0, el.selectionStart);
      const secondHalfText = el.value.substring(el.selectionEnd);
      const newCursorPos = el.selectionStart + msgVar.length;

      setFieldValue(`message${messageTab + 1}`, `${firstHalfText}${msgVar}${secondHalfText}`);

      setTimeout(() => {
        el.setSelectionRange(newCursorPos, newCursorPos);
        el.focus();
      }, 100);
    }
  };

  const renderMessageField = (identifier, setFieldValue, touched, errors, values, showAttachmentButton = false, isSubmitting = false) => {
    const messageValue = values[identifier] || "";
    const characterCount = messageValue.length;
    const maxCharacters = 1000;
    
    return (
      <>
        <TextField
          id={identifier}
          name={identifier}
          fullWidth
          rows={5}
          label={i18n.t(`campaigns.dialog.form.${identifier}`)}
          placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
          multiline={true}
          variant="outlined"
          disabled={!campaignEditable && campaign.status !== "CANCELADA"}
          value={messageValue}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue.length <= maxCharacters) {
              setFieldValue(identifier, newValue);
            }
          }}
          error={touched[identifier] && Boolean(errors[identifier])}
          helperText={touched[identifier] && errors[identifier]}
          className={classes.textField}
          inputProps={{ maxLength: maxCharacters }}
        />
        {/* ✅ Contador de caracteres + Botón ADJUNTAR ARCHIVO en la misma línea */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginTop: 4,
          marginBottom: 8
        }}>
          <Typography 
            variant="caption" 
            style={{ 
              color: characterCount > maxCharacters ? '#d32f2f' : '#666'
            }}
          >
            Maximo {characterCount}/{maxCharacters} caracteres
          </Typography>
          {showAttachmentButton && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {(campaign.mediaPath || attachment) && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <AttachFileIcon style={{ color: '#666', fontSize: 20 }} />
                  <Typography 
                    variant="body2" 
                    style={{ 
                      color: '#666',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4
                    }}
                  >
                    {attachment != null
                      ? (
                          attachmentInfo 
                            ? (
                                <>
                                  <span style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {attachmentInfo.fullName || attachmentInfo.name}
                                  </span>
                                  <span style={{ color: '#999', fontSize: '0.875rem' }}>
                                    ({attachmentInfo.size})
                                  </span>
                                </>
                              )
                            : (
                                <>
                                  <span style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {attachment.name}
                                  </span>
                                  <span style={{ color: '#999', fontSize: '0.875rem' }}>
                                    ({formatFileSize(attachment.size)})
                                  </span>
                                </>
                              )
                        )
                      : (
                          <>
                            <span style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {campaign.mediaName}
                            </span>
                            {campaign.mediaSize && (
                              <span style={{ color: '#999', fontSize: '0.875rem' }}>
                                ({formatFileSize(campaign.mediaSize)})
                              </span>
                            )}
                          </>
                        )}
                  </Typography>
                  {campaignEditable && (
                    <IconButton
                      onClick={() => setConfirmationOpen(true)}
                      color="secondary"
                      size="small"
                      style={{ marginLeft: 4 }}
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  )}
                </div>
              )}
              {!attachment && !campaign.mediaPath && campaignEditable && (
                <Button
                  color="primary"
                  onClick={() => {
                    attachmentFile.current.click();
                    handleAttachFile();
                  }}
                  disabled={isSubmitting || isFileListSelected}
                  variant="outlined"
                  startIcon={<AttachFileIcon />}
                  size="small"
                >
                  {i18n.t("campaigns.dialog.buttons.attach")}
                </Button>
              )}
            </div>
          )}
        </div>
        <MessageVariablesPicker
          disabled={!campaignEditable && campaign.status !== "CANCELADA"}
          onClick={value => handleClickMsgVar(value, setFieldValue)}
        />
      </>
    );
  };

  const renderConfirmationMessageField = (identifier, setFieldValue, values) => {
    return (
      <TextField
        id={identifier}
        name={identifier}
        fullWidth
        rows={5}
        label={i18n.t(`campaigns.dialog.form.${identifier}`)}
        placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
        multiline={true}
        variant="outlined"
        disabled={!campaignEditable && campaign.status !== "CANCELADA"}
        value={values[identifier] || ""}
        onChange={(e) => setFieldValue(identifier, e.target.value)}
        className={classes.textField}
      />
    );
  };

  const cancelCampaign = async () => {
    try {
      await api.post(`/campaigns/${campaign.id}/cancel`);
      toast.success(i18n.t("campaigns.toasts.cancel"));
      setCampaign((prev) => ({ ...prev, status: "CANCELADA" }));
      resetPagination();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const restartCampaign = async () => {
    try {
      await api.post(`/campaigns/${campaign.id}/restart`);
      toast.success(i18n.t("campaigns.toasts.restart"));
      setCampaign((prev) => ({ ...prev, status: "EM_ANDAMENTO" }));
      resetPagination();
    } catch (err) {
      // ✅ MEJORA UX: Mostrar errores importantes en modal
      const errorMsg = err?.response?.data?.error || err?.message || String(err);
      if (errorMsg.includes("No es permitido") || errorMsg.includes("en proceso") || errorMsg.includes("FINALIZADA")) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      } else {
        toast.error(err.message);
      }
    }
  };

  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={i18n.t("campaigns.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={deleteMedia}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      {/* ✅ MEJORA UX: Modal de error mejorado para notificaciones importantes */}
      <Dialog
        open={errorModalOpen}
        onClose={() => {
          setErrorModalOpen(false);
          // ✅ CORRECCIÓN: Limpiar el mensaje de error al cerrar el modal
          setErrorMessage("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ 
          backgroundColor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          padding: theme.spacing(2),
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(1)
        }}>
          <span role="img" aria-label="Error" style={{ fontSize: '1.5rem' }}>⚠️</span>
          <span style={{ fontWeight: 'bold' }}>Error de Validación</span>
        </DialogTitle>
        <DialogContent style={{ 
          padding: theme.spacing(3),
          paddingTop: theme.spacing(2)
        }}>
          <Typography 
            component="div"
            style={{ 
              whiteSpace: 'pre-line',
              fontSize: '1rem',
              lineHeight: '1.8',
              color: theme.palette.text.primary,
              padding: theme.spacing(2),
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 0, 0, 0.1)' : 'rgba(255, 0, 0, 0.05)',
              borderRadius: '4px',
              border: `1px solid ${theme.palette.error.light}`,
              fontFamily: 'inherit'
            }}
          >
            {errorMessage || "Ocurrió un error al guardar la campaña."}
          </Typography>
          
          {/* ✅ MEJORA: Mostrar información adicional si es conflicto de horarios */}
          {errorMessage && (errorMessage.includes("Horario no disponible") || errorMessage.includes("Conflicto con") || errorMessage.includes("Siguiente disponible")) && (
            <Box style={{ 
              marginTop: theme.spacing(2),
              padding: theme.spacing(2),
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 193, 7, 0.1)' : 'rgba(255, 193, 7, 0.1)',
              borderRadius: '4px',
              border: `1px solid ${theme.palette.warning.light}`
            }}>
              <Typography variant="body2" style={{ 
                color: theme.palette.warning.dark,
                fontWeight: 'bold',
                marginBottom: theme.spacing(1)
              }}>
                <span role="img" aria-label="Sugerencia">💡</span> Sugerencia:
              </Typography>
              <Typography variant="body2" style={{ 
                color: theme.palette.text.secondary,
                lineHeight: '1.6'
              }}>
                Por favor, ajusta la fecha y hora programada para evitar conflictos con otras campañas activas.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions style={{ 
          padding: theme.spacing(2),
          borderTop: `1px solid ${theme.palette.divider}`
        }}>
          <Button 
            onClick={() => {
              setErrorModalOpen(false);
              // ✅ CORRECCIÓN: Limpiar el mensaje de error al cerrar el modal
              setErrorMessage("");
            }} 
            color="primary" 
            variant="contained"
            style={{
              minWidth: '120px',
              fontWeight: 'bold'
            }}
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={datePastModalOpen}
        onClose={() => {
          setDatePastModalOpen(false);
          setPendingSetFieldValue(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Fecha pasada">📅</span> Fecha en el pasado
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{datePastMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setDatePastModalOpen(false);
              setPendingSetFieldValue(null);
            }} 
            color="default"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button 
            onClick={() => {
              // ✅ ACEPTAR: Actualizar fecha a hora actual + 2 minutos
              const timezone = getCampaignTimezoneSync();
              const nowInCompanyTimezone = moment().tz(timezone);
              // Calcular hora actual + 2 minutos
              const newScheduledAt = nowInCompanyTimezone.add(2, 'minutes').format('YYYY-MM-DD HH:mm:ss');
              
              if (pendingSetFieldValue) {
                // Actualizar el campo en el formulario
                pendingSetFieldValue('scheduledAt', newScheduledAt);
              }
              
              // Si hay valores pendientes de guardado, actualizar scheduledAt y continuar
              if (pendingSaveValues && saveCampaignRef.current) {
                const updatedValues = { ...pendingSaveValues, scheduledAt: newScheduledAt };
                setPendingSaveValues(null);
                setDatePastModalOpen(false);
                setPendingSetFieldValue(null);
                // Continuar con el guardado (saltando validación de fecha pasada y tiempo corto)
                setTimeout(() => {
                  saveCampaignRef.current(updatedValues, true, true);
                }, 100);
              } else {
                setDatePastModalOpen(false);
                setPendingSetFieldValue(null);
                setPendingSaveValues(null);
              }
            }} 
            color="primary" 
            variant="contained"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={formatInvalidModalOpen}
        onClose={() => setFormatInvalidModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Formato inválido">⚠️</span> Formato de archivo no permitido
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{formatInvalidMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFormatInvalidModalOpen(false)} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={sizeExceededModalOpen}
        onClose={() => setSizeExceededModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Tamaño excedido">⚠️</span> Tamaño de archivo excedido
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{sizeExceededMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSizeExceededModalOpen(false)} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={shortTimeModalOpen}
        onClose={() => {
          setShortTimeModalOpen(false);
          setShortTimeMessage("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Tiempo corto">⏰</span> Tiempo de programación muy corto
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{shortTimeMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              // ✅ CANCELAR: Cerrar modal sin hacer nada
              setShortTimeModalOpen(false);
              setShortTimeMessage("");
              setPendingScheduledAt(null);
            }} 
            color="default"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button 
            onClick={async () => {
              // ✅ ENTENDIDO: Aceptar la hora seleccionada y continuar
              const pendingSetFieldValueFn = pendingSetFieldValue;
              const scheduledAtValue = pendingScheduledAt;
              const pendingValues = pendingSaveValues;
              const saveFn = saveCampaignRef.current;
              
              // Cerrar modal
              setShortTimeModalOpen(false);
              setShortTimeMessage("");
              
              // Si viene desde onChange del campo, actualizar el campo
              if (pendingSetFieldValueFn && scheduledAtValue) {
                pendingSetFieldValueFn('scheduledAt', scheduledAtValue);
              }
              
              // Si viene desde handleSaveCampaign (botón AGREGAR), continuar con el guardado
              if (saveFn && pendingValues) {
                // Continuar con el guardado saltando la validación de tiempo corto
                setTimeout(() => {
                  saveFn(pendingValues, false, true); // shouldSkipShortTimeCheck = true
                }, 100);
              }
              
              // Limpiar valores pendientes
              setPendingScheduledAt(null);
            }} 
            color="primary" 
            variant="contained"
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {campaignEditable ? (
            <>
              {campaignId
                ? `${i18n.t("campaigns.dialog.update")}`
                : currentCampaignType === 'RECURRENTE'
                  ? `NUEVA CAMPAÑA - RECURRENTE`
                  : `NUEVA CAMPAÑA - ÚNICA`}
            </>
          ) : (
            <>{`${i18n.t("campaigns.dialog.readonly")} - ${currentCampaignType === 'RECURRENTE' ? 'RECURRENTE' : 'ÚNICA'}`}</>
          )}
        </DialogTitle>
        <div style={{ display: "none" }}>
          <input
            type="file"
            ref={attachmentFile}
            onChange={(e) => handleAttachmentFile(e)}
          />
        </div>
        <Formik
          key={formKey} // ✅ CRÍTICO: Key para forzar reinicialización completa cuando se resetea el formulario
          initialValues={campaign}
          enableReinitialize={true}
          validate={validateForm}
          onSubmit={async (values, actions) => {
            // ✅ CORRECCIÓN: Marcar todos los campos con errores como "touched" para mostrar errores visualmente
            const validationErrors = validateForm(values);
            if (Object.keys(validationErrors).length > 0) {
              // ✅ CORRECCIÓN: Establecer errores y marcar campos como touched
              // Esto asegura que Formik reconozca los errores y los muestre visualmente
              actions.setErrors(validationErrors);
              
              // ✅ CORRECCIÓN: Crear un objeto completo de touched para todos los campos con errores
              const touchedFields = {};
              Object.keys(validationErrors).forEach(fieldName => {
                touchedFields[fieldName] = true;
              });
              // Marcar todos los campos con errores como touched de una vez
              actions.setTouched(touchedFields);
              
              // ✅ CORRECCIÓN: Cambiar a la pestaña que contiene el primer campo con error
              // Si el error es en RECURRENCIA, ir a esa pestaña
              if (validationErrors.recurrenceType || validationErrors.recurrenceInterval) {
                setConfigTab(0); // Pestaña RECURRENCIA
              } else if (validationErrors.message1 || validationErrors.message2 || validationErrors.message3 || validationErrors.message4 || validationErrors.message5) {
                setConfigTab(currentCampaignType === 'RECURRENTE' ? 1 : 0); // Pestaña MENSAJE
              }
              
              // No continuar con el submit si hay errores
              actions.setSubmitting(false);
              return;
            }
            
            try {
              await handleSaveCampaign(values, false, false, actions.setFieldValue);
            } catch (error) {
              // El error ya se maneja dentro de handleSaveCampaign
              console.error('[CampaignModal] Error en onSubmit:', error);
            } finally {
              // ✅ Asegurar que el formulario se desbloquee siempre, incluso si hay errores
              // ✅ CRÍTICO: Verificar que el componente esté montado antes de actualizar estado
              if (isMounted.current) {
              actions.setSubmitting(false);
              }
            }
          }}
        >
          {({ values, errors, touched, isSubmitting, setFieldValue, resetForm }) => {
            // ✅ DEBUG: Loggear cuando el nombre cambia (sin usar hooks, solo en render)
            // Nota: Este log se ejecutará en cada render, pero es útil para debugging
            // En producción, se puede comentar o remover
            // ✅ FASE 4: Calcular tiempo estimado directamente desde los valores actuales
            const currentCalculatedTime = selectedContactListCount && selectedContactListCount > 0
              ? calculateEstimatedTime(
                  selectedContactListCount,
                  values.messageInterval || 45,
                  values.longerIntervalAfter || 20,
                  values.greaterInterval || 60
                )
              : null;
            
            return (
              <Form>
              <DialogContent dividers className={classes.dialogContent}>
                <Grid spacing={2} container>
                  <Grid xs={12} item>
                    <TextField
                      label={
                        <span>
                          <span role="img" aria-label="Nombre de campaña">📝</span> {i18n.t("campaigns.dialog.form.name")}
                        </span>
                      }
                      name="name"
                      value={values.name || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Limitar a 40 caracteres en tiempo real
                        if (value.length <= 40) {
                          // ✅ CRÍTICO: Guardar el último valor escrito en el ref (fuente de verdad)
                          lastWrittenNameRef.current = value;
                          
                          // ✅ CRÍTICO: Actualizar tanto Formik como el estado campaign para mantener sincronización
                          setFieldValue('name', value);
                          // ✅ CRÍTICO: Actualizar también el estado campaign para evitar que enableReinitialize sobrescriba
                          setCampaign((prev) => ({ ...prev, name: value }));
                          // ✅ CORRECCIÓN: Limpiar error de nombre duplicado cuando el usuario cambia el nombre
                          if (errorMessage && (errorMessage.includes("nombre de campaña") || errorMessage.includes("ya existe"))) {
                            setErrorMessage("");
                            setErrorModalOpen(false);
                          }
                        }
                      }}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name ? errors.name : ""}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.textField}
                      disabled={!campaignEditable}
                      inputProps={{
                        maxLength: 40,
                        minLength: 3
                      }}
                    />
                  </Grid>
                  {/* <Grid xs={12} md={3} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="confirmation-selection-label">
                        {i18n.t("campaigns.dialog.form.confirmation")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.confirmation")}
                        placeholder={i18n.t(
                          "campaigns.dialog.form.confirmation"
                        )}
                        labelId="confirmation-selection-label"
                        id="confirmation"
                        name="confirmation"
                        error={
                          touched.confirmation && Boolean(errors.confirmation)
                        }
                        disabled={!campaignEditable}
                      >
                        <MenuItem value={false}>Desabilitada</MenuItem>
                        <MenuItem value={true}>Habilitada</MenuItem>
                      </Field>
                    </FormControl>
                  </Grid> */}
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={`${classes.formControl} ${classes.selectField}`}
                    >
                      <InputLabel id="contactList-selection-label">
                        <span role="img" aria-label="Lista de contactos">📋</span> {i18n.t("campaigns.dialog.form.contactList")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={
                          <span>
                            <span role="img" aria-label="Lista de contactos">📋</span> {i18n.t("campaigns.dialog.form.contactList")}
                          </span>
                        }
                        placeholder={i18n.t(
                          "campaigns.dialog.form.contactList"
                        )}
                        labelId="contactList-selection-label"
                        id="contactListId"
                        name="contactListId"
                        error={
                          touched.contactListId && Boolean(errors.contactListId)
                        }
                        disabled={Boolean(!campaignEditable || (values.tagListId && values.tagListId !== ""))}
                        onChange={(e) => handleContactListChange(e.target.value, setFieldValue)}
                      >
                        <MenuItem value=""><span role="img" aria-label="No definido">❌</span> {i18n.t("campaigns.placeholders.notDefined")}</MenuItem>
                        {contactLists &&
                          contactLists.map((contactList) => (
                            <MenuItem
                              key={contactList.id}
                              value={contactList.id}
                            >
                              <span role="img" aria-label="Contactos">👥</span> {contactList.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={`${classes.formControl} ${classes.selectField}`}
                    >
                      <InputLabel id="tagList-selection-label">
                        <span role="img" aria-label="Lista de etiquetas">🏷️</span> {i18n.t("campaigns.dialog.form.tagList")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={
                          <span>
                            <span role="img" aria-label="Lista de etiquetas">🏷️</span> {i18n.t("campaigns.dialog.form.tagList")}
                          </span>
                        }
                        placeholder={i18n.t("campaigns.dialog.form.tagList")}
                        labelId="tagList-selection-label"
                        id="tagListId"
                        name="tagListId"
                        error={touched.tagListId && Boolean(errors.tagListId)}
                        disabled={Boolean(!campaignEditable || (values.contactListId && values.contactListId !== ""))}
                        onChange={(e) => handleTagListChange(e.target.value, setFieldValue)}
                      >
                        <MenuItem value=""><span role="img" aria-label="No definido">❌</span> {i18n.t("campaigns.placeholders.notDefined")}</MenuItem>
                        {Array.isArray(tagLists) &&
                          tagLists.map((tagList) => (
                            <MenuItem key={tagList.id} value={tagList.id}>
                              <span role="img" aria-label="Etiqueta">🏷️</span> {tagList.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={`${classes.formControl} ${classes.selectField}`}
                    >
                      <InputLabel id="whatsapp-selection-label">
                        <span role="img" aria-label="Conexión WhatsApp">📱</span> {i18n.t("campaigns.dialog.form.whatsapp")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={
                          <span>
                            <span role="img" aria-label="Conexión WhatsApp">📱</span> {i18n.t("campaigns.dialog.form.whatsapp")}
                          </span>
                        }
                        placeholder={i18n.t("campaigns.dialog.form.whatsapp")}
                        labelId="whatsapp-selection-label"
                        id="whatsappId"
                        name="whatsappId"
                        error={touched.whatsappId && Boolean(errors.whatsappId)}
                        disabled={!campaignEditable}
                        renderValue={() => {
                          if (!values.whatsappId || values.whatsappId === "") {
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                                <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                <span>{i18n.t("campaigns.placeholders.notDefinedMale") || "Seleccione una conexión"}</span>
                              </div>
                            );
                          }
                          const whatsapp = whatsapps?.find(w => w.id === Number(values.whatsappId));
                          if (!whatsapp) {
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                                <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                <span>{i18n.t("campaigns.placeholders.notDefinedMale") || "Seleccione una conexión"}</span>
                              </div>
                            );
                          }
                          return (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {whatsapp.name || `Conexión ${whatsapp.id}`}
                                  </span>
                                  <span 
                                    style={{ 
                                      fontSize: '10px', 
                                      padding: '2px 6px', 
                                      borderRadius: '10px',
                                      backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    {whatsapp.status || 'DISCONNECTED'}
                                  </span>
                                </div>
                                <span style={{ fontSize: '12px', color: '#666' }}>
                                  {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                                   whatsapp.name ? whatsapp.name : 
                                   `Conexión ${whatsapp.id}`}
                                </span>
                              </div>
                            </div>
                          );
                        }}
                      >
                        <MenuItem value=""><span role="img" aria-label="No definido">❌</span> {i18n.t("campaigns.placeholders.notDefinedMale")}</MenuItem>
                        {whatsapps &&
                          whatsapps.map((whatsapp) => (
                            <MenuItem dense key={whatsapp.id} value={whatsapp.id}>
                              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <span style={{ marginRight: '8px', fontSize: '16px' }} role="img" aria-label="WhatsApp">📱</span>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                      {whatsapp.name || `Conexión ${whatsapp.id}`}
                                    </span>
                                    <span 
                                      style={{ 
                                        fontSize: '10px', 
                                        padding: '2px 6px', 
                                        borderRadius: '10px',
                                        backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                                        color: 'white',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      {whatsapp.status || 'DISCONNECTED'}
                                    </span>
                                  </div>
                                  <span style={{ fontSize: '12px', color: '#666' }}>
                                    {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                                     whatsapp.name ? whatsapp.name : 
                                     `Conexión ${whatsapp.id}`}
                                  </span>
                                </div>
                              </div>
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>
                  <Grid xs={12} md={4} item>
                    <DateTimePickerWithTimezone
                      label={
                        <span>
                          <span role="img" aria-label="Fecha programada">📅</span> {
                            // ✅ CORRECCIÓN: Para campañas RECURRENTES activas, mostrar "Próxima Ejecución"
                            (values.tipo === 'RECURRENTE' || values.isRecurring) && 
                            values.executionCount && 
                            values.executionCount > 0 && 
                            (values.status === 'PROGRAMADA' || values.status === 'ACTIVA')
                              ? "Próxima Ejecución"
                              : i18n.t("campaigns.dialog.form.scheduledAt")
                          }
                        </span>
                      }
                      value={values.scheduledAt || null}
                      onChange={(newValue) => {
                        // ✅ OPCIÓN 1: Actualizar el campo inmediatamente sin validar (evita confusión mientras edita)
                        // La validación se hará en onBlur cuando el usuario termine de editar
                        setFieldValue('scheduledAt', newValue || "");
                        
                        // ✅ CRÍTICO: Sincronizar también el estado campaign para evitar que enableReinitialize sobrescriba valores
                        // Esto asegura que cuando Formik se reinicialice, tenga los valores más recientes
                        setCampaign((prev) => ({ ...prev, scheduledAt: newValue || "" }));
                        
                        // ✅ CORRECCIÓN: Limpiar error de nombre duplicado cuando el usuario cambia la fecha/hora
                        if (errorMessage && (errorMessage.includes("nombre de campaña") || errorMessage.includes("ya existe"))) {
                          setErrorMessage("");
                          setErrorModalOpen(false);
                        }
                      }}
                      onBlur={() => {
                        // ✅ OPCIÓN 1: Validar solo cuando el usuario termina de editar (onBlur)
                        // Esto evita validaciones confusas mientras el usuario está escribiendo
                        const currentValue = values.scheduledAt;
                        if (currentValue && currentValue !== "") {
                          // ✅ CORRECCIÓN CRÍTICA: Usar getCampaignTimezoneSync() en lugar de localStorage.getItem("timezone")
                          const campaignTimezone = getCampaignTimezoneSync();
                          
                          // Parsear en zona empresa para validaciones
                          const selectedMoment = moment.tz(currentValue, 'YYYY-MM-DD HH:mm:ss', campaignTimezone);
                          const nowInCompanyTimezone = moment().tz(campaignTimezone);
                          const diffMinutes = selectedMoment.diff(nowInCompanyTimezone, 'minutes', true);
                          
                          // ✅ OPCIÓN 3: Mensaje más claro con ambas fechas visibles
                          if (diffMinutes < -1) {
                            // Fecha pasada - mostrar modal con mensaje mejorado
                            const pastDiffMinutes = nowInCompanyTimezone.diff(selectedMoment, 'minutes');
                            const formattedSelected = selectedMoment.format('DD/MM/YYYY HH:mm');
                            const formattedNow = nowInCompanyTimezone.format('DD/MM/YYYY HH:mm');
                            setDatePastMessage(
                              `La fecha seleccionada (${formattedSelected}) es anterior a la hora actual (${formattedNow}).\n\nDiferencia: ${pastDiffMinutes} minutos en el pasado.\n\n¿Desea actualizar la fecha a ahora mismo (hora actual + 2 minutos) para enviar la campaña inmediatamente?`
                            );
                            setPendingSetFieldValue(() => setFieldValue);
                            setDatePastModalOpen(true);
                          } else if (diffMinutes > 0 && diffMinutes < 10) {
                            // ✅ REGLA DE NEGOCIO: Fecha futura pero < 10 minutos - mostrar modal informativo
                            const formattedDate = selectedMoment.format('DD/MM/YYYY HH:mm');
                            setShortTimeMessage(
                              `La fecha programada (${formattedDate}) está a menos de 10 minutos (${Math.ceil(diffMinutes)} minutos). Si programa con menos de 10 minutos, no tendrá opción a modificar esta campaña ya que los tiempos son muy cortos para su procesamiento. Se sugiere programar envíos mayores a 30 minutos.`
                            );
                            setPendingSetFieldValue(() => setFieldValue);
                            setPendingScheduledAt(currentValue);
                            setShortTimeModalOpen(true);
                          }
                        }
                      }}
                      timezone={companyTimezone || getCampaignTimezoneSync()}
                      error={touched.scheduledAt && Boolean(errors.scheduledAt)}
                      helperText={
                        touched.scheduledAt && errors.scheduledAt 
                          ? errors.scheduledAt 
                          : (values.tipo === 'RECURRENTE' || values.isRecurring) && 
                            values.executionCount && 
                            values.executionCount > 0 && 
                            values.originalScheduledAt
                              ? `Primera ejecución: ${moment.tz(values.originalScheduledAt, 'YYYY-MM-DD HH:mm:ss', getCampaignTimezoneSync()).format('DD/MM/YYYY HH:mm')}`
                              : undefined
                      }
                      disabled={!campaignEditable}
                      minDate={(() => {
                        // Calcular fecha mínima en zona empresa
                        const tz = companyTimezone || getCampaignTimezoneSync();
                        const nowInCompanyTimezone = moment().tz(tz);
                        // Extraer valores para crear Date "falso"
                        const year = nowInCompanyTimezone.year();
                        const month = nowInCompanyTimezone.month();
                        const day = nowInCompanyTimezone.date();
                        const hour = nowInCompanyTimezone.hour();
                        const minute = nowInCompanyTimezone.minute();
                        return new Date(year, month, day, hour, minute);
                      })()}
                    />
                  </Grid>
                  <Grid xs={12} md={4} item>
                  <FormControl
                      variant="outlined"
                      margin="dense"
                      className={`${classes.FormControl} ${classes.selectField}`}
                      fullWidth
                    >
                      <InputLabel id="fileListId-selection-label"><span role="img" aria-label="Lista de archivos">📁</span> {i18n.t("campaigns.dialog.form.fileList")}</InputLabel>
                      <Field
                        as={Select}
                        label={
                          <span>
                            <span role="img" aria-label="Lista de archivos">📁</span> {i18n.t("campaigns.dialog.form.fileList")}
                          </span>
                        }
                        name="fileListId"
                        id="fileListId"
                        placeholder={i18n.t("campaigns.dialog.form.fileList")}
                        labelId="fileListId-selection-label"
                        value={values.fileListId || ""}
                        disabled={Boolean(isAttachmentSelected) || !campaignEditable}
                        onChange={(e) => handleFileListChange(e.target.value, setFieldValue)}
                      >
                        <MenuItem value={""} ><span role="img" aria-label="No definido">❌</span> {i18n.t("campaigns.placeholders.notDefinedMale")}</MenuItem>
                        {file.map(f => (
                          <MenuItem key={f.id} value={f.id}>
                            <span role="img" aria-label="Archivo">📁</span> {f.name}
                          </MenuItem>
                        ))}
                      </Field>
                    </FormControl>
                  </Grid>
                  {/* Grid independiente para el mensaje de total de contactos - Ubicado después de Lista de Archivos */}
                  <Grid xs={12} md={4} item>
                    {selectedContactListCount !== null && values.contactListId && values.contactListId !== "" && (
                      <Typography 
                        variant="body2" 
                        style={{ 
                          marginTop: '8px', 
                          color: '#d32f2f',
                          fontWeight: 'bold',
                          fontSize: '0.875rem',
                          padding: '8px 0'
                        }}
                      >
                        TOTAL MENSAJES A ENVIAR DE LA LISTA "{contactLists.find(list => list.id === parseInt(values.contactListId))?.name || ''}" ES {selectedContactListCount}
                      </Typography>
                    )}
                  </Grid>
                  
                  {/* ✅ FASE 4: TABS PRINCIPALES SEGÚN TIPO DE CAMPAÑA */}
                  <Grid xs={12} item>
                    <Divider style={{ margin: '20px 0' }} />
                    <Tabs
                      value={configTab}
                      indicatorColor="primary"
                      textColor="primary"
                      onChange={(e, v) => setConfigTab(v)}
                      variant="fullWidth"
                      centered
                      style={{
                        borderRadius: 2,
                        marginBottom: 20,
                      }}
                    >
                      {currentCampaignType === 'RECURRENTE' && (
                        <Tab label={<><span role="img" aria-label="Recurrencia">🔄</span> RECURRENCIA</>} />
                      )}
                      <Tab label={<><span role="img" aria-label="Mensaje">💬</span> MENSAJE</>} />
                      <Tab label={<><span role="img" aria-label="Intervalo">⏱️</span> INTERVALO</>} />
                      <Tab label={<><span role="img" aria-label="Etiquetado">🏷️</span> ETIQUETADO</>} />
                    </Tabs>
                  </Grid>
                  
                  {/* ✅ FASE 4: CONTENIDO DE TABS - RECURRENCIA (solo para RECURRENTE) */}
                  {currentCampaignType === 'RECURRENTE' && configTab === 0 && (
                    <Grid xs={12} item>
                    <Typography variant="h6" style={{ marginBottom: '16px' }}>
                        <span role="img" aria-label="Recurrencia">🔄</span> Configuración Recurrente
                    </Typography>
                    
                    {/* ✅ ELIMINADO: Switch "Habilitar Recurrencia" - Ya no es necesario porque si está en esta pestaña es porque ya es RECURRENTE */}
                    
                      <Grid spacing={2} container style={{ marginTop: '8px' }}>
                        {/* Tipo de Recurrencia */}
                        <Grid xs={12} md={6} item>
                          <FormControl 
                            variant="outlined" 
                            fullWidth 
                            margin="dense"
                            className={`${classes.formControl} ${classes.selectField}`}
                            error={touched.recurrenceType && Boolean(errors.recurrenceType)}
                          >
                            <InputLabel id="recurrenceType-selection-label">
                              Tipo de Recurrencia
                            </InputLabel>
                            <Field
                              as={Select}
                              name="recurrenceType"
                              label="Tipo de Recurrencia"
                              labelId="recurrenceType-selection-label"
                              id="recurrenceType"
                              disabled={!campaignEditable}
                            >
                              <MenuItem value="">Seleccione un tipo</MenuItem>
                              <MenuItem value="diaria">Diaria</MenuItem>
                              <MenuItem value="semanal">Semanal</MenuItem>
                              <MenuItem value="quincenal">Quincenal</MenuItem>
                              <MenuItem value="mensual">Mensual</MenuItem>
                              <MenuItem value="anual">Anual</MenuItem>
                            </Field>
                            {/* ✅ CORRECCIÓN: Mostrar error debajo del campo como helperText */}
                            {touched.recurrenceType && errors.recurrenceType && (
                              <Typography variant="caption" color="error" style={{ marginLeft: '14px', marginTop: '3px', display: 'block' }}>
                                {errors.recurrenceType}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        
                        {/* Intervalo */}
                        <Grid xs={12} md={6} item>
                          <TextField
                            label="Intervalo"
                            name="recurrenceInterval"
                            type="number"
                            value={values.recurrenceInterval === undefined || values.recurrenceInterval === null || values.recurrenceInterval === "" ? "" : values.recurrenceInterval}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || val === null || val === undefined) {
                                setFieldValue('recurrenceInterval', "");
                              } else {
                                const numVal = parseInt(val, 10);
                                setFieldValue('recurrenceInterval', isNaN(numVal) ? "" : numVal);
                              }
                            }}
                            disabled={!campaignEditable}
                            helperText={
                              touched.recurrenceInterval && errors.recurrenceInterval 
                                ? errors.recurrenceInterval 
                                : "Ejemplo: 1 = cada día, 2 = cada 2 días/semanas/meses"
                            }
                            inputProps={{ min: 1, step: 1 }}
                            error={touched.recurrenceInterval && Boolean(errors.recurrenceInterval)}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            className={classes.textField}
                          />
                        </Grid>
                        
                        {/* Días de la Semana (solo si tipo = "semanal") */}
                        {values.recurrenceType === "semanal" && (
                          <Grid xs={12} item>
                            <FormControl 
                              variant="outlined" 
                              fullWidth 
                              margin="dense"
                              className={`${classes.formControl} ${classes.selectField}`}
                            >
                              <InputLabel id="recurrenceDaysOfWeek-selection-label">
                                Días de la Semana
                              </InputLabel>
                              <Select
                                multiple
                                value={(() => {
                                  try {
                                    if (!values.recurrenceDaysOfWeek || values.recurrenceDaysOfWeek === "" || values.recurrenceDaysOfWeek === null) {
                                      return [];
                                    }
                                    // Intentar parsear como JSON
                                    let parsed;
                                    if (typeof values.recurrenceDaysOfWeek === 'string') {
                                      parsed = JSON.parse(values.recurrenceDaysOfWeek);
                                    } else if (Array.isArray(values.recurrenceDaysOfWeek)) {
                                      parsed = values.recurrenceDaysOfWeek;
                                    } else {
                                      return [];
                                    }
                                    // Asegurar que sea un array de números
                                    if (Array.isArray(parsed)) {
                                      return parsed.map(d => typeof d === 'number' ? d : parseInt(d, 10)).filter(d => !isNaN(d));
                                    }
                                    return [];
                                  } catch (e) {
                                    // Si falla el parse, intentar como string de números separados por comas
                                    try {
                                      const str = String(values.recurrenceDaysOfWeek).replace(/[[\]]/g, '');
                                      const numbers = str.split(',').map(n => parseInt(n.trim(), 10)).filter(n => !isNaN(n));
                                      return numbers;
                                    } catch (e2) {
                                      return [];
                                    }
                                  }
                                })()}
                                onChange={(e) => {
                                  const days = e.target.value;
                                  setFieldValue('recurrenceDaysOfWeek', JSON.stringify(days));
                                }}
                                disabled={!campaignEditable}
                                labelId="recurrenceDaysOfWeek-selection-label"
                                label="Días de la Semana"
                                error={touched.recurrenceDaysOfWeek && Boolean(errors.recurrenceDaysOfWeek)}
                                renderValue={(selected) => {
                                  const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
                                  return selected.map((day) => dayNames[day]).join(', ');
                                }}
                              >
                                {[0, 1, 2, 3, 4, 5, 6].map((day) => {
                                  const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
                                  // Obtener el array de días desde el value del Select (ya parseado arriba)
                                  const selectedDays = (() => {
                                    try {
                                      if (!values.recurrenceDaysOfWeek || values.recurrenceDaysOfWeek === "" || values.recurrenceDaysOfWeek === null) {
                                        return [];
                                      }
                                      let parsed;
                                      if (typeof values.recurrenceDaysOfWeek === 'string') {
                                        parsed = JSON.parse(values.recurrenceDaysOfWeek);
                                      } else if (Array.isArray(values.recurrenceDaysOfWeek)) {
                                        parsed = values.recurrenceDaysOfWeek;
                                      } else {
                                        return [];
                                      }
                                      if (Array.isArray(parsed)) {
                                        return parsed.map(d => typeof d === 'number' ? d : parseInt(d, 10)).filter(d => !isNaN(d));
                                      }
                                      return [];
                                    } catch (e) {
                                      try {
                                        const str = String(values.recurrenceDaysOfWeek).replace(/[[\]]/g, '');
                                        const numbers = str.split(',').map(n => parseInt(n.trim(), 10)).filter(n => !isNaN(n));
                                        return numbers;
                                      } catch (e2) {
                                        return [];
                                      }
                                    }
                                  })();
                                  return (
                                    <MenuItem key={day} value={day}>
                                      <Checkbox checked={selectedDays.includes(day)} />
                                      <ListItemText primary={dayNames[day]} />
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              {touched.recurrenceDaysOfWeek && errors.recurrenceDaysOfWeek && (
                                <Typography variant="caption" color="error" style={{ marginLeft: '14px', marginTop: '3px' }}>
                                  {errors.recurrenceDaysOfWeek}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>
                        )}
                        
                        {/* Día del Mes (solo si tipo = "mensual") */}
                        {values.recurrenceType === "mensual" && (
                          <Grid xs={12} md={6} item>
                            <TextField
                              label="Día del Mes"
                              name="recurrenceDayOfMonth"
                              type="number"
                              value={values.recurrenceDayOfMonth || ''}
                              onChange={(e) => setFieldValue('recurrenceDayOfMonth', parseInt(e.target.value) || null)}
                              disabled={!campaignEditable}
                              helperText="Día del mes (1-31)"
                              inputProps={{ min: 1, max: 31 }}
                              error={touched.recurrenceDayOfMonth && Boolean(errors.recurrenceDayOfMonth)}
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              className={classes.textField}
                            />
                          </Grid>
                        )}
                        
                        {/* Fecha Final */}
                        <Grid xs={12} md={6} item>
                          <TextField
                            label="Fecha Final (Opcional)"
                            name="recurrenceEndDate"
                            type="datetime-local"
                            value={values.recurrenceEndDate || ''}
                            onChange={(e) => setFieldValue('recurrenceEndDate', e.target.value)}
                            disabled={!campaignEditable}
                            helperText="Dejar vacío para recurrencia infinita"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            className={classes.textField}
                          />
                        </Grid>
                        
                        {/* Máximo de Ejecuciones */}
                        <Grid xs={12} md={6} item>
                          <TextField
                            label="Máximo de Ejecuciones (Opcional)"
                            name="maxExecutions"
                            type="number"
                            value={values.maxExecutions || ''}
                            onChange={(e) => setFieldValue('maxExecutions', parseInt(e.target.value) || null)}
                            disabled={!campaignEditable}
                            helperText="Dejar vacío para ilimitado"
                            inputProps={{ min: 1 }}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            className={classes.textField}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  
                  {/* ✅ FASE 4: CONTENIDO DE TABS - MENSAJE */}
                  {((currentCampaignType === 'UNICA' && configTab === 0) || (currentCampaignType === 'RECURRENTE' && configTab === 1)) && (
                  <Grid xs={12} item>
                    <Tabs
                      value={messageTab}
                      indicatorColor="primary"
                      textColor="primary"
                      className={classes.tabmsg}
                      onChange={(e, v) => setMessageTab(v)}
                      variant="fullWidth"
                      centered
                      style={{
                        borderRadius: 2,
                      }}
                    >
                      <Tab label="Msg. 1" index={0} />
                      <Tab label="Msg. 2" index={1} />
                      <Tab label="Msg. 3" index={2} />
                      <Tab label="Msg. 4" index={3} />
                      <Tab label="Msg. 5" index={4} />
                    </Tabs>
                    <Box style={{ paddingTop: 20, border: "none" }}>
                      {messageTab === 0 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                  <>{renderMessageField("message1", setFieldValue, touched, errors, values, false, isSubmitting)}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage1", setFieldValue, values
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                              <>{renderMessageField("message1", setFieldValue, touched, errors, values, true, isSubmitting)}</>
                          )}
                        </>
                      )}
                      {messageTab === 1 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                  <>{renderMessageField("message2", setFieldValue, touched, errors, values, true, isSubmitting)}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage2", setFieldValue, values
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message2", setFieldValue, touched, errors, values)}</>
                          )}
                        </>
                      )}
                      {messageTab === 2 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                  <>{renderMessageField("message3", setFieldValue, touched, errors, values, true, isSubmitting)}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage3", setFieldValue, values
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                              <>{renderMessageField("message3", setFieldValue, touched, errors, values, true, isSubmitting)}</>
                          )}
                        </>
                      )}
                      {messageTab === 3 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                  <>{renderMessageField("message4", setFieldValue, touched, errors, values, true, isSubmitting)}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage4", setFieldValue, values
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                              <>{renderMessageField("message4", setFieldValue, touched, errors, values, true, isSubmitting)}</>
                          )}
                        </>
                      )}
                      {messageTab === 4 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                  <>{renderMessageField("message5", setFieldValue, touched, errors, values, true, isSubmitting)}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage5", setFieldValue, values
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                              <>{renderMessageField("message5", setFieldValue, touched, errors, values, true, isSubmitting)}</>
                          )}
                        </>
                      )}
                    </Box>
                    </Grid>
                  )}

                  {/* ✅ FASE 4: CONTENIDO DE TABS - INTERVALO */}
                  {((currentCampaignType === 'UNICA' && configTab === 1) || (currentCampaignType === 'RECURRENTE' && configTab === 2)) && (
                    <Grid xs={12} item>
                      <Typography variant="h6" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: 16 }}>
                      <span role="img" aria-label="Configuración">⚙️</span> Configuración de Intervalos
                    </Typography>

                      {/* ✅ CORRECCIÓN: El cálculo se hace arriba en el render usando currentCalculatedTime */}
                      {/* Ya no necesitamos actualizar calculatedTime aquí porque el panel usa currentCalculatedTime directamente */}

                      {/* ✅ Campos en UNA SOLA FILA */}
                      <Grid spacing={2} container>
                  {/* Tiempo entre mensajes */}
                        <Grid xs={12} sm={4} item>
                    <TextField
                      label="Tiempo Inicial (segundos)"
                      name="messageInterval"
                      type="number"
                            value={values.messageInterval || 45}
                            onChange={(e) => {
                              const val = parseInt(e.target.value) || 45;
                              setFieldValue('messageInterval', val);
                            }}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      inputProps={{ min: 5, max: 300 }}
                      className={classes.textField}
                      disabled={!campaignEditable && campaign.status !== "CANCELADA"}                      
                    />
                  </Grid>

                  {/* Aplicar intervalo mayor después de X contactos */}
                        <Grid xs={12} sm={4} item>
                    <TextField
                      label="Luego de X contactos"
                      name="longerIntervalAfter"
                      type="number"
                      value={values.longerIntervalAfter || 20}
                            onChange={(e) => {
                              const val = parseInt(e.target.value) || 20;
                              setFieldValue('longerIntervalAfter', val);
                            }}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      inputProps={{ min: 1, max: 100 }}
                      className={classes.textField}
                      disabled={!campaignEditable && campaign.status !== "CANCELADA"}                      
                    />
                  </Grid>

                  {/* Intervalo mayor entre mensajes */}
                        <Grid xs={12} sm={4} item>
                    <TextField
                      label="Nuevo tiempo de envio"
                      name="greaterInterval"
                      type="number"
                      value={values.greaterInterval || 60}
                            onChange={(e) => {
                              const val = parseInt(e.target.value) || 60;
                              setFieldValue('greaterInterval', val);
                            }}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      inputProps={{ min: 10, max: 600 }}
                      className={classes.textField}
                      disabled={!campaignEditable && campaign.status !== "CANCELADA"}                      
                    />
                        </Grid>
                  </Grid>

                      {/* ✅ FASE 4: Panel de Cálculo Dinámico */}
                      {/* ✅ CORRECCIÓN: Usar currentCalculatedTime (calculado en render) en lugar de calculatedTime (estado) */}
                      {selectedContactListCount && selectedContactListCount > 0 && currentCalculatedTime && (
                        <Grid xs={12} item style={{ marginTop: 24 }}>
                          <Paper style={{ padding: 20, backgroundColor: theme.palette.background.paper }}>
                            <Typography variant="h6" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: 16 }}>
                              <span role="img" aria-label="Estadísticas">📊</span> TIEMPO DE ENVÍO ESTIMADO
                            </Typography>
                            
                            <Typography variant="body2" style={{ marginBottom: 8 }}>
                              <strong>Lista de contacto:</strong> {contactLists.find(list => list.id === parseInt(values.contactListId))?.name || 'N/A'}
                            </Typography>
                            <Typography variant="body2" style={{ marginBottom: 16, color: '#d32f2f', fontWeight: 'bold' }}>
                              <span role="img" aria-label="Importante">🔴</span> <strong>Contiene:</strong> {selectedContactListCount} contactos
                            </Typography>
                            
                            <Divider style={{ margin: '16px 0' }} />
                            
                            <Typography variant="subtitle2" style={{ marginBottom: 8, fontWeight: 'bold' }}>
                              Desglose Paso a Paso:
                            </Typography>
                            
                            <Typography variant="body2" style={{ marginBottom: 4 }}>
                              <strong>Paso 1:</strong> Primeros {values.longerIntervalAfter || 20} contactos × {values.messageInterval || 45} segundos = {Math.min(values.longerIntervalAfter || 20, selectedContactListCount) * (values.messageInterval || 45)} segundos
                            </Typography>
                            
                            {selectedContactListCount > (values.longerIntervalAfter || 20) && (
                              <>
                                <Typography variant="body2" style={{ marginBottom: 4 }}>
                                  <strong>Paso 2:</strong> Contactos restantes = {selectedContactListCount} - {values.longerIntervalAfter || 20} = {selectedContactListCount - (values.longerIntervalAfter || 20)} contactos
                                </Typography>
                                <Typography variant="body2" style={{ marginBottom: 4 }}>
                                  {selectedContactListCount - (values.longerIntervalAfter || 20)} contactos × {values.greaterInterval || 60} segundos = {Math.max(0, selectedContactListCount - (values.longerIntervalAfter || 20) - 1) * (values.greaterInterval || 60)} segundos
                                </Typography>
                              </>
                            )}
                            
                            <Typography variant="body2" style={{ marginBottom: 4 }}>
                              <strong>Paso 3:</strong> Tiempo total = {currentCalculatedTime.segundos} segundos
                            </Typography>
                            
                            <Typography variant="body2" style={{ marginBottom: 16 }}>
                              <strong>Paso 4:</strong> {currentCalculatedTime.segundos} segundos ÷ 60 = {currentCalculatedTime.minutos} minutos
                              {currentCalculatedTime.horas > 0 && (
                                <> = {currentCalculatedTime.horas} hora{currentCalculatedTime.horas > 1 ? 's' : ''} {currentCalculatedTime.minutosRestantes} minuto{currentCalculatedTime.minutosRestantes !== 1 ? 's' : ''}</>
                              )}
                            </Typography>
                            
                            <Divider style={{ margin: '16px 0' }} />
                            
                            <Typography variant="h6" style={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
                              <span role="img" aria-label="Resultado">✅</span> Resultado final:
                            </Typography>
                            <Typography variant="body1" style={{ fontWeight: 'bold', marginTop: 8 }}>
                              Tiempo estimado: {currentCalculatedTime.segundos} segundos = {currentCalculatedTime.texto}
                            </Typography>
                          </Paper>
                        </Grid>
                      )}
                    </Grid>
                  )}
                  
                  {/* ✅ FASE 4: CONTENIDO DE TABS - ETIQUETADO - Etiquetado Automático */}
                  {((currentCampaignType === 'UNICA' && configTab === 2) || (currentCampaignType === 'RECURRENTE' && configTab === 3)) && (
                    <Grid xs={12} item>
                      <Paper style={{ padding: 20, backgroundColor: theme.palette.background.paper, marginBottom: 16 }}>
                        <Typography variant="h6" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: 16 }}>
                          <span role="img" aria-label="Etiquetas">🎯</span> Configuración de ETIQUETAS por Envío de Campañas
                        </Typography>
                        
                        <Typography 
                          variant="body2" 
                          style={{ 
                            marginBottom: 16,
                            color: theme.palette.text.primary // ✅ Color adaptativo para modo dark
                          }}
                        >
                          Activa el etiquetado automático para los contactos que reciban y respondan a esta campaña. 
                          Cuando un contacto responda a los mensajes de la campaña, se le aplicará automáticamente 
                          la etiqueta que selecciones a continuación. Esto te permitirá identificar fácilmente qué 
                          contactos interactuaron con esta campaña específica.
                        </Typography>
                        
                        {/* ✅ Checkbox para activar/desactivar etiquetado AUTOMÁTICO (independiente de tagListId) */}
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.autoTagEnabled || false}
                              onChange={(e) => {
                                setFieldValue('autoTagEnabled', e.target.checked);
                                if (!e.target.checked) {
                                  // Si se desactiva, limpiar autoTagId
                                  setFieldValue('autoTagId', '');
                                }
                              }}
                              disabled={!campaignEditable}
                              color="primary"
                            />
                          }
                          label={values.autoTagEnabled ? "Activado" : "Desactivado"}
                          style={{ 
                            marginBottom: 16,
                            color: theme.palette.text.primary // ✅ Color adaptativo para modo dark
                          }}
                        />
                        
                        {/* ✅ Mensaje de advertencia si está desactivado */}
                        {!values.autoTagEnabled && (
                          <Paper 
                            style={{ 
                              padding: 16, 
                              backgroundColor: '#fff3cd', 
                              border: '1px solid #ffc107',
                              marginBottom: 16,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8
                            }}
                          >
                            <span role="img" aria-label="Advertencia" style={{ fontSize: '20px' }}>⚠️</span>
                            <div>
                              <Typography 
                                variant="body2" 
                                style={{ 
                                  fontWeight: 'bold', 
                                  marginBottom: 4,
                                  color: '#856404' // ✅ Color oscuro para texto en fondo amarillo (modo dark compatible)
                                }}
                              >
                                Etiqueta de Campaña Envío DESACTIVADA
                              </Typography>
                              <Typography 
                                variant="body2"
                                style={{ 
                                  color: '#856404' // ✅ Color oscuro para texto en fondo amarillo (modo dark compatible)
                                }}
                              >
                                Para activar Etiqueta a Campaña de Envíos, primero activa la detección automática arriba
                              </Typography>
                            </div>
                          </Paper>
                        )}
                        
                        {/* ✅ Dropdown para seleccionar etiqueta si está activado */}
                        {values.autoTagEnabled && (
                          <Grid xs={12} item style={{ marginTop: 16 }}>
                            <Typography 
                              variant="subtitle2" 
                              style={{ 
                                marginBottom: 8, 
                                fontWeight: 'bold',
                                color: theme.palette.text.primary // ✅ Color adaptativo para modo dark
                              }}
                            >
                              SI LO ACTIVA REALIZARÁ
                            </Typography>
                            <FormControl
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              className={`${classes.formControl} ${classes.selectField}`}
                            >
                              <InputLabel id="autoTag-selection-label">
                                Seleccione la Etiqueta a vincular
                              </InputLabel>
                              <Select
                                value={values.autoTagId || ""}
                                onChange={(e) => setFieldValue('autoTagId', e.target.value || null)}
                                disabled={!campaignEditable}
                                labelId="autoTag-selection-label"
                                label="Seleccione la Etiqueta a vincular"
                                error={touched.autoTagId && Boolean(errors.autoTagId)}
                              >
                                <MenuItem value="">
                                  <span role="img" aria-label="No definido">❌</span> No definido
                                </MenuItem>
                                {Array.isArray(tagLists) &&
                                  tagLists.map((tagList) => (
                                    <MenuItem key={tagList.id} value={tagList.id}>
                                      <span role="img" aria-label="Etiqueta">🏷️</span> {tagList.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                      </Paper>
                    </Grid>
                  )}
                  

                </Grid>
              </DialogContent>
              <DialogActions className={classes.dialogActions} style={{ justifyContent: 'flex-end', padding: '16px 24px', gap: 8 }}>
                {campaign.status === "CANCELADA" && (
                  <Button
                    color="primary"
                    onClick={() => restartCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.restart")}
                  </Button>
                )}
                {campaign.status === "EM_ANDAMENTO" && (
                  <Button
                    color="primary"
                    onClick={() => cancelCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.cancel")}
                  </Button>
                )}
                {/* ✅ Botón CERRAR - siempre visible en TODAS las pestañas */}
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                  style={{ borderColor: '#d32f2f', color: '#d32f2f' }}
                >
                  {i18n.t("campaigns.dialog.buttons.close")}
                </Button>
                {/* ✅ Botón ENVIAR CAMPAÑA / AGREGAR / EDITAR - siempre visible en TODAS las pestañas */}
                {(campaignEditable || campaign.status === "CANCELADA") && (
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {campaignId
                      ? `${i18n.t("campaigns.dialog.buttons.edit")}`
                      : "ENVIAR CAMPAÑA"}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                )}
              </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </div>
  );
};

export default CampaignModal;
